module.exports = __webpack_public_path__ + "img/left_right_layout_1.eb750223.png";